<template>
  <div>
    <FullPageLoader />
    <main id="main-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script setup>
import axios from "axios";
import FullPageLoader from "./components/FullPageLoader.vue";
import { ref, provide, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const loading = ref(false);
provide("loading", loading);

watch(() => route.path, () => {
  window.scrollTo(0, 0);
}, { immediate: true });

axios.interceptors.request.use(
  (config) => {
    loading.value = true;
    return config;
  },
  (error) => {
    loading.value = false;
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    loading.value = false;
    return response;
  },
  (error) => {
    loading.value = false;
    return Promise.reject(error);
  }
);
</script>

<style lang="scss" scoped></style>
